/**
 * HIPAA Compliance Security Configuration
 * 
 * This file contains security configurations aligned with HIPAA requirements:
 * - Session timeout policies
 * - Token expiration settings
 * - Security event logging
 * - Access control settings
 */

export const HIPAA_SECURITY_CONFIG = {
  // Session Management (HIPAA recommends 5 minutes for healthcare apps)
  SESSION_TIMEOUT_MINUTES: 5,
  SESSION_WARNING_MINUTES: 4, // Warn user 1 minutes before timeout

  // Security Headers
  SECURITY_HEADERS: {
    'X-Content-Type-Options': 'nosniff',
    'X-Frame-Options': 'DENY',
    'X-XSS-Protection': '1; mode=block',
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
    'Content-Security-Policy': "default-src 'self'; script-src 'self' 'unsafe-inline'; style-src 'self' 'unsafe-inline'",
  },
  
  // Audit Logging
  AUDIT_EVENTS: {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGOUT: 'LOGOUT',
    SESSION_TIMEOUT: 'SESSION_TIMEOUT',
    ACCESS_DENIED: 'ACCESS_DENIED',
    TOKEN_REFRESH: 'TOKEN_REFRESH',
    PHI_ACCESS: 'PHI_ACCESS',
    UNAUTHORIZED_ACCESS_ATTEMPT: 'UNAUTHORIZED_ACCESS_ATTEMPT',
  },
  
  ENCRYPT_SENSITIVE_DATA: true,
  CLEAR_DATA_ON_LOGOUT: true,
  
  // Error Handling
  SANITIZE_ERROR_MESSAGES: true, // Never expose PHI in error messages
  LOG_ERRORS_SECURELY: true,
};

/**
 * HIPAA-compliant cache configuration for MSAL
 */
export const HIPAA_MSAL_CACHE_CONFIG = {
  cacheLocation: 'sessionStorage' as const,
  storeAuthStateInCookie: false, // Set to true only if supporting IE11
  secureCookies: true, // Ensure cookies are secure in production
};

/**
 * Session timeout configuration
 */
export const SESSION_CONFIG = {
  idleTimeoutMs: HIPAA_SECURITY_CONFIG.SESSION_TIMEOUT_MINUTES * 60 * 1000,
  warningTimeoutMs: HIPAA_SECURITY_CONFIG.SESSION_WARNING_MINUTES * 60 * 1000,
};

